import BaseService from './BaseService';

class EmailConfigService extends BaseService{

  constructor() {
    super({ path: 'email-config' });
  }
}

export default new EmailConfigService();
